import axiosConfig from './axiosConfig';

// Upload document
export const uploadDocument = async (formData) => {
    try {
        const response = await axiosConfig.post('document', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response;
    } catch (error) {
        throw error || 'Failed to upload document';
    }
};

// List documents
export const getDocuments = async (queryParams = {}) => {
    try {
        const response = await axiosConfig.get('document', {
            params: queryParams
        });
        return response;
    } catch (error) {
        throw error || 'Failed to get documents';
    }
};

// Update document
export const updateDocument = async (id, data) => {
    try {
        const response = await axiosConfig.put(`document/${id}`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response;
    } catch (error) {
        throw error || 'Failed to update document';
    }
};

// Delete document
export const deleteDocument = async (id) => {
    try {
        const response = await axiosConfig.delete(`document/${id}`);
        return response;
    } catch (error) {
        throw error || 'Failed to delete document';
    }
};
